import React from 'react';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CircularProgress from '@material-ui/core/CircularProgress'; 

function ResetInfoDialog(props) {
  const { onClose, open, isError, isCompleted } = props;

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="reset-info-dialog" open={open} >
      { isCompleted && !isError && <DialogTitle id="reset-info-dialog">Aktion erfolgreich durchgeführt</DialogTitle> }
      { isError && !isCompleted && <DialogTitle id="reset-info-dialog">Aktion konnte nicht durchgeführt werden</DialogTitle>}
      { !isError && !isCompleted && <DialogTitle id="reset-info-dialog"><CircularProgress/></DialogTitle> }
    </Dialog>
  );
}

ResetInfoDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

export default ResetInfoDialog;